import { Box, Text } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { formatCurrency } from '../../../../../helpers/formatters'

import styles from './HomeValueEstimate.module.scss'

interface HomeValueEstimateProps {
  avm: number
}

export const MSG = defineMessages({
  estimatedValue: {
    id: 'General.estimatedValue',
    defaultMessage: 'Estimated Value'
  }
})

export const HomeValueEstimate = ({ avm }: HomeValueEstimateProps) => {
  const intl = useIntl()

  return (
    <Box
      display='flex'
      alignItems='center'
      flexDirection='column'
      padding={['0 0', '0 15%']}
      marginTop='4'
      marginBottom={0}
      width={'100%'}
    >
      <Text
        className={styles.centerAvm}
        fontWeight='light'
        data-qa='center-avm'
        color='brand'
        display='block'
        size='2xl'
      >
        {formatCurrency(avm)}
      </Text>
      <Text data-qa='estimated-value-text' display='block' size='2xs'>
        {intl.formatMessage(MSG.estimatedValue)}
      </Text>
    </Box>
  )
}
